import { atom } from 'recoil';
import { getRecoil, setRecoil } from 'recoil-nexus';
import _ from 'lodash';

import { NotifyTypeEnum } from "src/constants/enums/notifyTypes";

interface INotifyMessage {
    id: string;
    type: NotifyTypeEnum;
    text: string | string[];
    description: string | string[];
}

const notifyMessagesStore = atom<INotifyMessage[]>({
    key: 'notifyMessagesStore',
    default: [],
});

export const storeAddNotifyMessage = (type: NotifyTypeEnum, text: string | string[], description: string | string[]) => {
   const newMessage = {
       id: _.uniqueId('notify_message'),
       type,
       text,
       description,
   };

   setRecoil(notifyMessagesStore, messages => [newMessage, ...messages]);

   return newMessage.id;
};

export const storeRemoveNotifyMessage = (id: string) => {
    setRecoil(notifyMessagesStore, messages => messages.filter(item => item.id !== id));
};

export default notifyMessagesStore;